import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productPriceStyles } from "@insite/content-library/Components/ProductPrice";

productPriceStyles.price = mergeToNew(productPriceStyles.price, {
    priceText: {
        weight: 700,
        color: "text.accent",
        size: 20,
        lineHeight: "28px",
    },
});

productPriceStyles.priceWrapper = mergeToNew(productPriceStyles.priceWrapper, {
    css: css`
        margin-top: 12px;
    `,
});
